module.exports = __webpack_public_path__ + "img/03_04.ee14ba5a.jpg";